import { render, staticRenderFns } from "./ProcedureForm.vue?vue&type=template&id=8b9dc43e&"
import script from "./ProcedureForm.vue?vue&type=script&lang=js&"
export * from "./ProcedureForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports